import { getStore } from "../components/common/StoreCommon";
import {
  feedThreadsAdded,
  feedThreadAdded,
  feedThreadLiked,
  feedThreadClosed,
  getFeedThreadById,
  getFeedThreads,
  feedThreadExpired,
  feedThreadHidden,
  feedThreadRemoved,
} from "../store/hub/boomFeed";

export default class FeedService {

  addThreads(threads) {
    getStore().dispatch(feedThreadsAdded({ threads }));
  }

  addThread(thread, visibleInFeed) {
    getStore().dispatch(feedThreadAdded({ ...thread, ...{ VisibleInFeed: visibleInFeed } }));
  }

  closeThread(threadId) {
    getStore().dispatch(feedThreadClosed({ threadId }));
  }

  likeThread(hubMessage) {
    getStore().dispatch(feedThreadLiked(hubMessage));
  }

  threadHasExpired(threadId) {
    this.hideThread(threadId);
    getStore().dispatch(feedThreadExpired({ threadId }));
  }

  hideThread(threadId) {
    getStore().dispatch(feedThreadHidden({ threadId }));
  }

  removeThread(threadId) {
    getStore().dispatch(feedThreadRemoved({ threadId }));
  }

  getThreadById(threadId) {
    return getFeedThreadById(this._getState())(threadId);
  }

  getThreads() {
    return getFeedThreads(this._getState())();
  }

  _getState() {
    return getStore().getState();
  }
}